package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.HistoryW500Rounded: ImageVector
    get() {
        if (_historyW500Rounded != null) {
            return _historyW500Rounded!!
        }
        _historyW500Rounded = Builder(name = "HistoryW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(479.52f, 848.13f)
                quadToRelative(-127.67f, 0.0f, -226.35f, -76.98f)
                quadToRelative(-98.67f, -76.98f, -129.34f, -196.93f)
                quadToRelative(-4.72f, -16.92f, 6.71f, -30.97f)
                quadToRelative(11.44f, -14.05f, 30.59f, -16.53f)
                quadToRelative(18.15f, -2.48f, 33.19f, 6.6f)
                quadToRelative(15.03f, 9.07f, 20.75f, 26.75f)
                quadToRelative(25.19f, 87.13f, 98.4f, 142.09f)
                quadToRelative(73.2f, 54.97f, 166.05f, 54.97f)
                quadToRelative(115.81f, 0.0f, 196.47f, -80.66f)
                quadTo(756.65f, 595.8f, 756.65f, 480.0f)
                reflectiveQuadToRelative(-80.66f, -196.47f)
                quadToRelative(-80.66f, -80.66f, -196.47f, -80.66f)
                quadToRelative(-66.13f, 0.0f, -124.22f, 29.97f)
                quadToRelative(-58.08f, 29.96f, -98.37f, 83.09f)
                horizontalLineToRelative(61.4f)
                quadToRelative(17.71f, 0.0f, 29.81f, 12.1f)
                quadToRelative(12.1f, 12.1f, 12.1f, 29.82f)
                reflectiveQuadToRelative(-12.1f, 29.93f)
                quadTo(336.04f, 400.0f, 318.33f, 400.0f)
                lineTo(159.28f, 400.0f)
                quadToRelative(-19.15f, 0.0f, -32.32f, -13.17f)
                quadToRelative(-13.18f, -13.18f, -13.18f, -32.33f)
                verticalLineToRelative(-158.8f)
                quadToRelative(0.0f, -17.72f, 12.1f, -29.7f)
                reflectiveQuadToRelative(29.82f, -11.98f)
                quadToRelative(17.71f, 0.0f, 29.69f, 11.98f)
                reflectiveQuadToRelative(11.98f, 29.7f)
                verticalLineToRelative(48.73f)
                quadToRelative(52.2f, -63.52f, 125.93f, -98.04f)
                quadToRelative(73.74f, -34.52f, 156.22f, -34.52f)
                quadToRelative(76.44f, 0.0f, 143.49f, 29.1f)
                quadToRelative(67.06f, 29.1f, 116.75f, 78.79f)
                quadToRelative(49.7f, 49.7f, 78.79f, 116.75f)
                quadToRelative(29.1f, 67.06f, 29.1f, 143.49f)
                reflectiveQuadToRelative(-29.1f, 143.49f)
                quadToRelative(-29.09f, 67.05f, -78.79f, 116.75f)
                quadToRelative(-49.69f, 49.69f, -116.75f, 78.79f)
                quadToRelative(-67.05f, 29.1f, -143.49f, 29.1f)
                close()
                moveTo(521.91f, 464.0f)
                lineToRelative(97.85f, 97.61f)
                quadToRelative(11.72f, 11.72f, 11.72f, 29.43f)
                quadToRelative(0.0f, 17.72f, -11.72f, 29.44f)
                quadToRelative(-11.72f, 11.72f, -29.43f, 11.72f)
                quadToRelative(-17.72f, 0.0f, -29.44f, -11.72f)
                lineTo(451.76f, 511.35f)
                quadToRelative(-6.72f, -6.72f, -10.08f, -15.06f)
                quadToRelative(-3.35f, -8.33f, -3.35f, -17.53f)
                verticalLineToRelative(-157.09f)
                quadToRelative(0.0f, -17.71f, 12.09f, -29.69f)
                quadTo(462.52f, 280.0f, 480.24f, 280.0f)
                reflectiveQuadToRelative(29.69f, 11.98f)
                quadToRelative(11.98f, 11.98f, 11.98f, 29.69f)
                lineTo(521.91f, 464.0f)
                close()
            }
        }
        .build()
        return _historyW500Rounded!!
    }

private var _historyW500Rounded: ImageVector? = null
